import { pushTrackerEvent } from '../_googleTagManager';

export default function linkSwitcher() {
  const linkSwitcher = document.querySelectorAll(".kirinus-link-switcher");
  let resizeTimer;

  function isElementInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  function checkLinkWidth(element) {
    // set rect position
    let slideRect = element.closest('.kirinus-link-switcher').querySelector('.kirinus-link-switcher__rect');
    slideRect.style.transform = `translateX(${element.offsetLeft}px)`;
    slideRect.style.width = `${element.offsetWidth}px`;
  }

  function setGradient(navLinks) {
    for (let link of navLinks) {
      const mq = window.matchMedia( "(min-width: 992px)" );

      let linkPadding = 24;
      let listWidth = link.offsetWidth;
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");
      ctx.font = "16px Arial Pro";
      let textWidth = ctx.measureText(link.querySelector('a').innerText);

      link.classList.remove('kirinus-link-switcher__item--no-gradient');

      if (mq.matches) {
        linkPadding = 34;
      }

      if (listWidth > (textWidth.width + linkPadding)) {
        link.classList.add('kirinus-link-switcher__item--no-gradient');
      }
    }
  }

  function setLiWith(element) {
    let navLinks = element.closest('.kirinus-link-switcher').querySelectorAll('.kirinus-link-switcher__item');

    navLinks.forEach((item) => {
      item.classList.remove("is-active");
    });

    element.classList.add("is-active");

    checkLinkWidth(element);
  }

  if (linkSwitcher) {
    for (let item of linkSwitcher) {
      const navLinks = item.querySelectorAll(".kirinus-link-switcher__item");
      const navigation = item.querySelector('ul');
      const slideRect = item.querySelector('.kirinus-link-switcher__rect');

      setGradient(navLinks);

      setTimeout(function () {
        item.classList.add('kirinus-link-switcher--ready');
      }, 500)

      item.querySelector('ul').setAttribute('data-max-width', `${navigation.offsetWidth}`);

      setLiWith(item.querySelector('.is-active'));

      item.addEventListener("click", (evt) => {
        evt.preventDefault();

        for (let element of navLinks) {
          element.style.pointerEvents = 'none';
        }

        let getLocation = function (href) {
          let l = document.createElement('a');
          l.href = href;
          return l;
        };

        let l = getLocation(window.location.href);
        let target_link = getLocation(evt.target.href);

        const clickedIndex = Array.from(navLinks).indexOf(this);
        const activeIndex = Array.from(navLinks).findIndex(div => div.classList.contains('is-active'));

        if (clickedIndex < activeIndex) {
          navLinks.forEach(function (div, index) {
            if (index < clickedIndex || index > activeIndex) {
              div.classList.add('hide-pseudo');
            } else {
              div.classList.remove('hide-pseudo');
            }
          });
        } else {
          navLinks.forEach(function (div, index) {
            if (index > clickedIndex || index < activeIndex) {
              div.classList.add('hide-pseudo');
            } else {
              div.classList.remove('hide-pseudo');
            }
          });
        }

        setLiWith(evt.target.parentNode);

        let switch_content = [];
        for (let element of navLinks) {
          switch_content.push(element.innerText.trim());
        }

        // Tracking
        pushTrackerEvent('guide.switch', {
          'tracking_feature': 'kirinus_guide_switch',
          'event_path': l.pathname,
          'event_url': window.location.href,
          'switch_count': navLinks.length,
          'switch_content': switch_content.join('|'),
          'target_url': evt.target.href,
          'target_path': target_link.pathname,
          'click_text': evt.target.innerText
        });

        slideRect.addEventListener("transitionend", () => {
          window.location.href = evt.target.getAttribute('href');
        });
      });

      window.addEventListener("resize", function (){
        checkLinkWidth(item.querySelector('.is-active'));
        slideRect.classList.add('is-resize');

        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          slideRect.classList.remove('is-resize');
        }, 500);

        setGradient(navLinks);
      });
    }
  }
}
